import DOMPurify from "dompurify";
export function sanitizeSvg(svgString) {
    if (!svgString || typeof svgString !== "string") return "";
    return DOMPurify.sanitize(svgString, {
        USE_PROFILES: {svg: true, svgFilters: true},
        ADD_ATTR: ["data-turnstile-id"],
        FORBID_TAGS: ["script", "foreignObject"],
        // "style" zakázán kvůli defense-in-depth: uložené SVG se renderuje inline
        // pro všechny prohlížející subjektu (stored-XSS threat model), a CSS uvnitř
        // style (např. url(javascript:...)) DOMPurify defaultně nesanitizuje.
        // Editor emituje jen presentation atributy (fill/stroke), takže nic neztratíme.
        FORBID_ATTR: ["onload", "onclick", "onmouseover", "style"],
    });
}

// Nahraný SVG podklad → bezpečné data:image/svg+xml (base64), které se vykreslí
// jako <image> (secure static mode prohlížeče = žádné skripty ani externí fetch).
//
// Proč RETURN_DOM + vynucené namespace místo prostého sanitizeSvg():
// reálné SVG (např. z Adobe Illustratoru) používá <defs> + <use xlink:href="#id">.
// Bez deklarace xmlns:xlink na kořeni není xlink:href well-formed XML → image/svg+xml
// (XML strict parser prohlížeče) selže a ukáže „broken image". Sanitizujeme do DOM,
// na kořenový <svg> vynutíme xmlns i xmlns:xlink a serializujeme (outerHTML) — výsledek
// je platný standalone SVG dokument.
// Styl (fill přes style=) tu NEzakazujeme — obsah jde jen do <image>, nikdy se
// neinlinuje, takže CSS-based útoky neplatí a barvy podkladu zůstanou.
export function svgToBackgroundDataUri(rawSvg) {
    if (!rawSvg || typeof rawSvg !== "string") return null;
    const dom = DOMPurify.sanitize(rawSvg, {
        USE_PROFILES: {svg: true, svgFilters: true},
        // <use xlink:href="#id"> vykresluje obsah z <defs> (běžné u Illustrator SVG).
        // DOMPurify je defaultně zahazuje; tady je povolíme, protože podklad se renderuje
        // výhradně jako <image> data-URI = browser secure static mode (žádné skripty,
        // externí fetch ani interakce), takže use/xlink nemůže nic zneužít.
        ADD_TAGS: ["use"],
        ADD_ATTR: ["xlink:href", "href"],
        FORBID_TAGS: ["script", "foreignObject"],
        FORBID_ATTR: ["onload", "onclick", "onmouseover"],
        RETURN_DOM: true,
    });
    const svg = dom && dom.querySelector ? dom.querySelector("svg") : null;
    if (!svg) return null;
    svg.setAttribute("xmlns", "http://www.w3.org/2000/svg");
    svg.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink");
    const xml = svg.outerHTML;
    return "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(xml)));
}
